{
  "best_play": {
    "tiles": [
      {
        "row": 0,
        "col": 4,
        "letter": "F"
      },
      {
        "row": 1,
        "col": 4,
        "letter": "I"
      },
      {
        "row": 2,
        "col": 4,
        "letter": "S"
      },
      {
        "row": 3,
        "col": 4,
        "letter": "H"
      },
      {
        "row": 4,
        "col": 4,
        "letter": "Y"
      }
    ],
    "words": [
      "FISHY",
      "CATS"
    ],
    "score": 56
  },
  "board_height": 5,
  "board_layout": [
    [
      0,
      0,
      0,
      0,
      0
    ],
    [
      0,
      1,
      0,
      0,
      0
    ],
    [
      0,
      0,
      0,
      0,
      2
    ],
    [
      0,
      0,
      -1,
      0,
      4
    ],
    [
      3,
      0,
      0,
      0,
      0
    ]
  ],
  "board_width": 5,
  "date": "tutorial",
  "play_count": 78,
  "play_scores": [
    {
      "score": 56,
      "count": 1
    },
    {
      "score": 48,
      "count": 2
    },
    {
      "score": 46,
      "count": 1
    },
    {
      "score": 40,
      "count": 1
    },
    {
      "score": 38,
      "count": 1
    },
    {
      "score": 33,
      "count": 1
    },
    {
      "score": 30,
      "count": 1
    },
    {
      "score": 24,
      "count": 3
    },
    {
      "score": 22,
      "count": 3
    },
    {
      "score": 20,
      "count": 1
    },
    {
      "score": 18,
      "count": 1
    },
    {
      "score": 16,
      "count": 2
    },
    {
      "score": 15,
      "count": 4
    },
    {
      "score": 13,
      "count": 6
    },
    {
      "score": 12,
      "count": 4
    },
    {
      "score": 11,
      "count": 1
    },
    {
      "score": 10,
      "count": 4
    },
    {
      "score": 9,
      "count": 5
    },
    {
      "score": 8,
      "count": 4
    },
    {
      "score": 7,
      "count": 4
    },
    {
      "score": 6,
      "count": 11
    },
    {
      "score": 5,
      "count": 4
    },
    {
      "score": 4,
      "count": 4
    },
    {
      "score": 3,
      "count": 6
    },
    {
      "score": 2,
      "count": 3
    }
  ],
  "player_letters": "FISHYRN",
  "pre_placed_words": [
    {
      "word": "CAT",
      "row": 2,
      "col": 1,
      "direction": "horizontal"
    }
  ]
}
